import { render, staticRenderFns } from "./data-download.vue?vue&type=template&id=184f9605&"
import script from "./data-download.vue?vue&type=script&lang=ts&"
export * from "./data-download.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports